import React, {Component} from "react";
import {LocalForm, Errors, Control} from "react-redux-form";

export default class UserForgot extends Component {
	render() {
		const required = (val) => val && val.length;
		return <div className="content">
			<p className="is-size-5 has-text-centered">Recuperar Contraseña</p>
			<p className="has-text-centered">
				Ingresa tu e-mail y haz clic en <strong>recuperar</strong> para recibir las instrucciones y recuperar tu contraseña.
			</p>
			{this.props.message && <p className="has-text-centered help is-success">{this.props.message}</p>}
			{this.props.error && <p className="has-text-centered help is-danger">{this.props.error}</p>}

			<LocalForm onSubmit={(val) => this._handleSubmit(val)}>
				<div className="field">
					<div className="control has-icon has-icon-left">
						<Control.text type="email" model=".username" className="input" placeholder="Usuario" autoFocus validators={{required}} />
						<span className="icon is-small is-left"><i className={`fa fa-envelope`}/></span>
					</div>
					<Errors className="help is-danger" model=".username" show="touched" messages={{
						required: 'Debes ingresar tu usuario',
						typeMismatch: 'El usuario que ingresaste es inválido'
					}}/>
				</div>

				<div className="level">
					<div className="level-left">
						<div className="level-item">
							<button onClick={() => this.props.setActionType('login')} className="button is-small">Regresar a iniciar sesión</button>
						</div>
					</div>
					<div className="level-right">
						<div className="level-item">
							<button className="button is-black">
								<span>Recuperar</span>
								<span className="icon is-small"><i className="fa fa-paper-plane"></i></span>
							</button>
						</div>
					</div>
				</div>
			</LocalForm>
		</div>
	}

	_handleSubmit(values) {
		this.props.userRecover(values);
	}
}


// WEBPACK FOOTER //
// ./src/elements/login/userForgotPassword.jsx